import "./facilityDetailsLocationsScreen.scss";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import React, {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import AddIcon from '@mui/icons-material/Add';
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {useDispatch, useSelector} from "react-redux";
import {setFacilityDetailsForLocation} from "../../../store/actions/facilityAndLocation.action";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {IRootReducerState} from "../../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import LocationListTableComponent from "../../location/location-list-table/LocationListTableComponent";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../shared/services/common.service";

interface FacilityDetailsLocationsComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}

const FacilityDetailsLocationsScreen = (props: FacilityDetailsLocationsComponentProps) => {

    const navigate = useNavigate();
    const params = useParams<{ facilityId: string | undefined }>();
    const {facilityId} = params;
    const [facilityDetails, setFacilityDetails] = useState<any>(undefined);
    const [isFacilityDetailsLoading, setIsFacilityDetailsLoading] = useState<boolean>(false);
    const [isFacilityDetailsLoaded, setIsFacilityDetailsLoaded] = useState<boolean>(false);
    const [isFacilityDetailsLoadingFailed, setIsFacilityDetailsLoadingFailed] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);



    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                facilityId: facilityId,
            };
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, facilityId]);


    useEffect(() => {
        if (facilityId) {
            dispatch(setCurrentNavParams("Back", "Facility", CommonService._routeConfig.FacilityListRoute()));
            dispatch(setSideMenuView('compact'));
        }
    }, [facilityId, dispatch, navigate]);

    const getFacilityDetails = useCallback(() => {
        const payload = {};
        let facilityDetails: any = {};
        setIsFacilityDetailsLoading(true);
        setIsFacilityDetailsLoaded(false);
        setIsFacilityDetailsLoadingFailed(false);
        CommonService._facility.getFacilityDetails(facilityId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    facilityDetails = response.data;
                }
                setFacilityDetails(facilityDetails);
                setIsFacilityDetailsLoading(false);
                setIsFacilityDetailsLoaded(true);
                setIsFacilityDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setFacilityDetails(facilityDetails);
                setIsFacilityDetailsLoading(false);
                setIsFacilityDetailsLoaded(false);
                setIsFacilityDetailsLoadingFailed(true);
            });
    }, [facilityId]);

    useEffect(() => {
        if (facilityId) {
            getFacilityDetails();
        }
    }, [facilityId, getFacilityDetails]);


    return (
        <div className={'facility-details-locations-screen view-screen screen'}>
            {
                isFacilityDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isFacilityDetailsLoadingFailed && <>
                    <StatusCardComponent title={"Facility details failed to load"}/>
                </>
            }
            {
                isFacilityDetailsLoaded && <div className="view-details-wrapper">

                    <CardComponent className={'view-details-header-wrapper'}>
                        <div className="card-content">
                            <div className="view-details-card-header-button-wrapper">
                                <div className="view-details-card-title">
                                    <div className={'view-details-card-title-text'}>
                                        {CommonService.capitalizeFirstLetterOfEachWord(facilityDetails?.name)}
                                    </div>
                                    <div className={'heading-status pdd-left-15'}>
                                        <ChipComponent
                                            label={CommonService.capitalizeFirstLetter(facilityDetails?.status)}
                                            className={facilityDetails?.status} variant={"outlined"}/>

                                    </div>
                                </div>
                                <div className="view-details-options">
                                    <ButtonComponent
                                        className={"white-space-nowrap"}
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={false}
                                        handleClick={() => {
                                            navigate(CommonService._routeConfig.FacilityDetailsRoute(facilityId))
                                        }}
                                    >
                                        View/Edit Details
                                    </ButtonComponent>
                                </div>
                            </div>
                            <div className="view-details-content">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Created on"}>
                                            <div className="view-details-value">
                                                <>
                                                    {commonService.formatDate(facilityDetails?.createdAt)}
                                                    &nbsp;|&nbsp;
                                                    {commonService.formatTime(facilityDetails?.createdAt)}
                                                </>
                                            </div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Added by"}>
                                            <div
                                                className="details-value">{commonService.capitalizeFirstLetterOfEachWord(facilityDetails?.createdByDetails?.firstName + " " + facilityDetails?.createdByDetails?.lastName)}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Facility Type"}>
                                            <div
                                                className="details-value">{commonService.capitalizeFirstLetterOfEachWord( facilityDetails?.type)}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"No. of Locations"}>
                                            <div
                                                className="details-value"> {facilityDetails?.numberOfLocations}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>

                                </Grid>
                            </div>
                        </div>
                    </CardComponent>

                    <div className="clear-fix"/>

                    <div className="location-list-screen mrg-top-25 screen">
                        <div className={"screen-content-wrapper"}>
                            <div className="page-data-wrapper">
                                <div className="page-options">
                                    <div className="page-search">
                                        <SearchComponent
                                            label={"Search Location"}
                                            id="search_input"
                                            placeholder={"Search Location"}
                                            value={filterData.search}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div className="page-extra-options">
                                        {commonService.checkAccess('Location',
                                    'locationAdd', currentUser?.userAccessModules) &&
                                    <>
                                    <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            variant={"contained"}
                                            id="add_location_button"
                                            disabled={!facilityDetails?.isActive}
                                            startIcon={<AddIcon/>}
                                            handleClick={() => {
                                                dispatch(setFacilityDetailsForLocation(facilityDetails));
                                                navigate(CommonService._routeConfig.LocationAddRoute());
                                            }}
                                        >
                                            New Location
                                        </ButtonComponent>&nbsp;
                                        </>
                                        }
                                    </div>
                                </div>
                                <div className="page-data-wrapper t-table-inside-details">
                                    <LocationListTableComponent
                                        filterData={filterData}
                                        isColumnFilterVisible={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );

};

export default FacilityDetailsLocationsScreen;
